/**
 * V2 entry point.
 *
 * - Prevents double init via dataset flag
 * - Wires listener/handler/render
 */

import { ProductThumbImageErrorHandlerRender } from "./product-thumb-image-error-handler-render";
import { ProductThumbImageErrorHandler } from "./product-thumb-image-error-handler-handler";
import { ProductThumbImageErrorHandlerListener } from "./product-thumb-image-error-handler-listener";
class ProductThumbImageErrorHandlerSetup {
    public static init(): void {
        const root = document.documentElement;
        if (!(root instanceof HTMLElement)) return;
        if (root.dataset.productThumbImageErrorHandlerInit === "1") return;
        root.dataset.productThumbImageErrorHandlerInit = "1";

        const render = new ProductThumbImageErrorHandlerRender();
        const handler = new ProductThumbImageErrorHandler({ render });
        const listener = new ProductThumbImageErrorHandlerListener({ handler });
        listener.register();
        handler.replaceAlreadyBrokenImages(document);
    }
}

export { ProductThumbImageErrorHandlerSetup };
